export const CONTENT_SOURCES = [
  {
    id: "pronam",
    label: "PRONAM",
    values: ["PRONAM"],
    className: "border-violet-200 bg-violet-50 text-violet-700",
  },
  {
    id: "gpc_vigente",
    label: "GPC vigentes",
    values: ["GPC", "GPC Vigente", "GPC vigente", "GPC Vigentes", "GPC vigentes"],
    className: "border-blue-200 bg-blue-50 text-blue-700",
  },
  {
    id: "gpc_historica",
    label: "GPC históricas",
    values: ["GPC Viejas", "GPC viejas", "GPC Viejas Seleccionadas"],
    className: "border-slate-200 bg-slate-50 text-slate-700",
  },
  {
    id: "nom",
    label: "NOM",
    values: ["NOM"],
    className: "border-cyan-200 bg-cyan-50 text-cyan-700",
  },
  {
    id: "consensos_mx",
    label: "Guías y consensos mexicanos",
    values: ["Guias y consensos mexicanos", "Guias y consensos", "GUIAS Y CONSENSOS MEXICANOS"],
    className: "border-emerald-200 bg-emerald-50 text-emerald-700",
  },
  {
    id: "acls",
    label: "ACLS",
    values: ["ACLS"],
    className: "border-rose-200 bg-rose-50 text-rose-700",
  },
  {
    id: "pals",
    label: "PALS",
    values: ["PALS"],
    className: "border-teal-200 bg-teal-50 text-teal-700",
  },
  {
    id: "atls",
    label: "ATLS",
    values: ["ATLS"],
    className: "border-amber-200 bg-amber-50 text-amber-800",
  },
] as const;

export type ContentSourceId = (typeof CONTENT_SOURCES)[number]["id"];

export function expandContentSourceIds(ids: ContentSourceId[]): string[] {
  const selected = new Set(ids);
  return CONTENT_SOURCES
    .filter((source) => selected.has(source.id))
    .flatMap((source) => [...source.values]);
}

export function getContentSourceLabel(id: ContentSourceId): string {
  return CONTENT_SOURCES.find((source) => source.id === id)?.label ?? id;
}
